export const discourseRoot = "https://discourse-earthcode.eox.at"